import { useEffect, useRef } from "react";

const Header = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      ref.current?.classList.add("revealed");
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollTo = (className: string) => {
    const el = document.getElementsByClassName(className)[0];
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const openUrl = (url: string) =>
    window.open(url, "_blank", "noopener,noreferrer");

  return (
    <div className="header reveal" ref={ref}>
      <div className="header-badge">
        <span className="header-badge-dot" />
        Intermediate Software Developer · Dayforce
      </div>

      <p className="header-greeting">Hey, I'm</p>

      <h1 className="header-name gradient-text">Arash Ghafoori</h1>

      <p className="header-desc">
        I'm a software engineer who loves turning ambitious ideas into
        thoughtful, reliable products. I specialize in backend and full-stack
        development, distributed systems, and developer tooling, and I use AI
        throughout my workflow to explore faster, solve harder problems, and
        build better software.
      </p>

      <div className="header-cta">
        <button
          className="header-cta-primary"
          onClick={() => scrollTo("contacts")}
        >
          Get in touch <span className="header-cta-arrow">→</span>
        </button>
        <button
          className="header-cta-secondary"
          onClick={() =>
            openUrl(
              "https://drive.google.com/file/d/1AJw9cfA7yD_MG3-KBc-XAy3FCpQZSur_/view?usp=drive_link"
            )
          }
        >
          View Resume ↗
        </button>
      </div>

      <div className="header-scroll-hint">
        <span />
      </div>
    </div>
  );
};

export default Header;
